module.exports = __webpack_public_path__ + "static/media/icon6.4faf93b1.svg";